export default __webpack_public_path__ + "static/media/icon-fullscreen.f62668a3.svg";